import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Main } from './main.service';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/core/auth.service';
import { CredentialsService } from 'src/app/core/credentials.service';
import { untilDestroyed } from 'src/app/core/until-destroyed';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @ViewChild('success') success: ElementRef;
  @ViewChild('error') error: ElementRef;
  title: string;
  notifications: any = [];
  today: Date;
  todays: string;
  options = {
    width: '00',
    tags: true
  };

  userLoggedIn: Object;

  constructor(private mainService: Main, public router: Router, private credentialsService: CredentialsService,
    private authService: AuthService, private route: ActivatedRoute) {
    this.today = new Date();
    var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    var newDay = dayNames[this.today.getDay()] + " " + monthNames[this.today.getMonth()] + ' ' + this.today.getDate() + ', ' + this.today.getFullYear();
    this.todays = newDay;
  }
  ngOnInit() {
    if (this.user) {
      this.getNotifications();
    }

  }

  valueChanged() { }

  notify(title: string) {
    this.title = title;
    document.getElementById('notifyModal').click();

  }

  getNotifications() {
    /*  this.adminService.getNotifications(1, true, '&status=unread&email=' + this.user.email)
       .pipe(
         finalize(() => { }),
         untilDestroyed(this)
       ).subscribe(
         (res: any) => {
           this.notifications = res.data;
         },
         err => {
         }
       ); */
  }

  signOut() {
    this.authService.signOut()
      .pipe(
        untilDestroyed(this)
      ).subscribe((res: any) => {
        localStorage.clear();
        /* localStorage.removeItem('access_token');
        localStorage.removeItem('user'); */
        this.mainService.toast({
          title: 'Signed Out!',
          body: 'User signed out!',
          type: 'info'
        });
        this.router.navigate(['/login']);
      },
        (err: any) => {
          console.log(err);
        }
      );
  }

  get user(): any | null {
    const credentials = this.authService.credentials;
    return credentials ? credentials : null;
  }

  ngOnDestroy() {

  }

  get credentials(): any | null {
    const credentials = this.credentialsService.credentials;
    return credentials ? credentials : null;
  }
}
